import {useCallback, useEffect, useState} from 'react';

import {useBlocker} from 'react-router-dom';

import useReport from '../../providers/useReport';
import useReportViews from '../../providers/useReportViews';

const useSaveViewBeforeLeavingReport = () => {
  const {selectedReport, reports, selectedProject} = useReport();
  const {saveReportView} = useReportViews();

  const [canNavigate, setCanNavigate] = useState(false);
  const [shouldProceed, setShouldProceed] = useState(false);

  const save = async () => {
    if (!selectedReport) return;

    const isCustomReport = reports.find(r => r.report_id === selectedReport.config.id)?.isCustomModel;
    if (isCustomReport || (!isCustomReport && selectedProject)) {
      const state = (await selectedReport.bookmarksManager.capture())?.state;
      const reportId = selectedReport.config.id;
      saveReportView({
        reportId,
        reportState: state
      });
    }
  };

  const shouldBlock = useCallback(
    ({currentLocation, nextLocation}) => {
      const pathsAreDifferent = currentLocation.pathname !== nextLocation.pathname;
      return !canNavigate && pathsAreDifferent;
    },
    [canNavigate]
  );

  const blocker = useBlocker(shouldBlock);
  const blocked = blocker.state === 'blocked';

  useEffect(() => {
    if (blocked && !shouldProceed) {
      save();
      setShouldProceed(true);
    }
  }, [blocked, shouldProceed]);

  useEffect(() => {
    if (blocked && shouldProceed) {
      setCanNavigate(true);
      blocker.proceed();
      setShouldProceed(false);
      setCanNavigate(false); // reset for next time
    }
  }, [blocked, shouldProceed, blocker]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      save();
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);
};

export default useSaveViewBeforeLeavingReport;
